/**
 * 서버 주소 설정 — 화면 코드는 환경변수를 직접 읽지 않고 여기서만 읽는다.
 * 지금은 빌드 시점 환경변수(.env.[mode])를 쓴다. 같은 빌드를 여러 환경에 올려야 하면
 * 이 함수만 런타임 설정(/config.json 등)을 읽도록 바꾸면 된다.
 */
const clean = (value: string | undefined) => {
  const trimmed = value?.trim();
  return trimmed === '' ? undefined : trimmed;
};

export const apiConfig = {
  coreApiUrl: clean(import.meta.env.VITE_CORE_API_URL),
  authApiUrl: clean(import.meta.env.VITE_AUTH_API_URL),
};
